var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97198 18H20.972C21.522 18 21.972 17.55 21.972 17C21.972 16.45 21.522 16 20.972 16H4.97198C4.42198 16 3.97198 16.45 3.97198 17C3.97198 17.55 4.42198 18 4.97198 18ZM4.97198 13H20.972C21.522 13 21.972 12.55 21.972 12C21.972 11.45 21.522 11 20.972 11H4.97198C4.42198 11 3.97198 11.45 3.97198 12C3.97198 12.55 4.42198 13 4.97198 13ZM3.97198 7C3.97198 7.55 4.42198 8 4.97198 8H20.972C21.522 8 21.972 7.55 21.972 7C21.972 6.45 21.522 6 20.972 6H4.97198C4.42198 6 3.97198 6.45 3.97198 7Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.3416881a7c8821d18d0a2af03110607e.svg";
export { ForwardRef as ReactComponent };